<div class="container py-5" style="max-width: 520px;">
  <div class="text-center mb-4">
    <h2 class="fw-bold mb-1">Recover your password</h2>
    <div class="text-muted">Enter the email address linked to your SwipFx account.</div>
  </div>

  <div class="alert alert-success" *ngIf="sent">
    If an account exists for that email address, a password reset link has been sent.
  </div>
  <div class="alert alert-danger" *ngIf="error">{{ error }}</div>

  <form class="card shadow-sm border-0" [formGroup]="form" (ngSubmit)="submit()" *ngIf="!sent">
    <div class="card-body p-4">
      <label class="form-label">Email</label>
      <input type="email" class="form-control" formControlName="email" autocomplete="email"
        [class.is-invalid]="submitted && form.controls.email.invalid" />
      <div class="invalid-feedback">Enter a valid email address.</div>

      <button class="btn btn-primary w-100 mt-4" type="submit" [disabled]="loading">
        <span *ngIf="loading" class="spinner-border spinner-border-sm me-2"></span>
        Send reset link
      </button>
    </div>
  </form>

  <div class="text-center mt-3">
    <a routerLink="/auth/login" class="text-decoration-none">Back to login</a>
  </div>
</div>
